import React, { useState, useEffect } from 'react';

const CookieDialog: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-blue-950 text-white p-4 shadow-lg z-50">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row justify-between items-center">
        {/* Text Section */}
        <div className="mb-4 sm:mb-0 sm:flex-1">
          <h2 className="text-base sm:text-lg font-semibold text-yellow-400 mb-2">
            We value your privacy
          </h2>
          <p className="text-sm sm:text-base leading-relaxed">
            This website uses cookies to ensure you get the best experience.
            Please accept cookies to help us improve your experience. You can
            decline if you wish.
          </p>
        </div>

        {/* Button Section */}
        <div className="flex gap-4">
          <button
            onClick={handleAccept}
            className="bg-blue-600 hover:bg-blue-500 text-white font-semibold py-2 px-4 rounded transition duration-300 text-sm sm:text-base"
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="bg-red-500 hover:bg-red-400 text-white font-semibold py-2 px-4 rounded transition duration-300 text-sm sm:text-base"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieDialog;
